module.exports = __webpack_public_path__ + "img/destination-mayan-riviera.738fc684.jpg";